module.exports = __webpack_public_path__ + "static/media/instructor-successful-teams3.0b876561.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/instructor-successful-teams3.png
// module id = 1061
// module chunks = 0